<template>
    <div class="" v-if="maintenance">
        <div class="maintanceWrapper">
            <div class="innerPanel">
                <div class="audioLogo"><img src="/static/img/logo.png"></div>
                <h1 class="heading">Maintenance</h1>
                <div class="subHeading">We're undergoing a bit of scheduled maintenance.</div>
                <p class="sorryText">Sorry for the inconvenience. We'll be back up and running as fast as possible.</p>
                <p>&mdash; The Cortex Team</p>
                <h1 class="heading">Travail d’entretien</h1>
                <div class="subHeading"> Afin d’améliorer la qualité de nos services, notre logiciel sera momentanément inaccessible</div>
                <p>
                    Veuillez nous excuser pour la gêne occasionné. Nous serons de retour aussi vite que possible.
                </p>
                <p>&mdash; L’équipe Cortex.</p>
                <div class="cortexLogo"><img src="/static/img/Navilution_Cortex_Logo_CMYK.jpg"/></div>
            </div>
        </div>
    </div>
    <div class="maintance-box" v-else-if="flagForActive">

        <article style="margin: 0 33%;">
            <div class="audioLogo1"><img src="/static/img/AudioConexus_Logo-Stacked_CMYK.jpg"></div>
            <div class="classCheckOtp">

                <form @submit.prevent="checkOtpSubmit()">
                    <div class="row">
                        <div class="col-12"><h3>Please enter the 6-digit verification code we sent via Email:</h3></div>
                        <div class="col-12" style="margin-top:5%;">
                            <md-input v-model="inputOTP" style="width:70%;" type="text"></md-input>
                        </div>
                        <div class="col-12" style="margin-top:5%; left:10%;">
                            <md-button id="sign-in" type="submit" style="width:70%;" class="md-primary md-ink-ripple md-raised">Send</md-button>
                            <br></br>
                            <span v-if="siginInErrorForOTP" class="md-error">Please enter correct OTP</span>
                        </div>
                    </div>
                </form>
            </div>
        </article>
    </div>
    <div class="maintance-box" v-else-if="flagForDeactive">
        <article style="margin: 0 33%;">
            <div class="audioLogo1"><img src="/static/img/AudioConexus_Logo-Stacked_CMYK.jpg"></div>
            <div class="classCheckOtp">
                <form @submit.prevent="checkOtpSubmit()">
                    <div class="row">
                        <div class="col-12"><h3>Please enter the 6-digit verification code we sent via Email:</h3></div>
                        <div class="col-12" style="margin-top:5%;">
                            <md-input v-model="inputOTP" style="width:70%;" type="text"></md-input>
                        </div>
                        <div class="col-12" style="margin-top:5%; left:10%;">
                            <md-button id="sign-in" type="submit" style="width:70%;" class="md-primary md-ink-ripple md-raised">Send
                            </md-button>
                            <br>
                            <span v-if="siginInErrorForOTP" class="md-error">Please enter correct OTP</span>
                        </div>
                    </div>
                </form>
            </div>
        </article>
    </div>
    <div class="login-box" v-else>
        <div class="div" v-if="count > 10">
        </div>
        <div v-else>
            <form @submit.prevent="signIn()">
                <em class="logo"></em>
                <div class="login-form">
                    <div class="col col-md-4 text-center my-auto">
                        <div class="fields">
                            <div class="line-item">
                                <md-field>
                                    <md-input id="email" v-model="email" type="email" placeholder="Email" class="login-input"></md-input>
                                </md-field>
                            </div>
                            <div class="line-item">
                                <md-field :md-toggle-password="false">
                                    <md-input :value.sync="password" v-model="password" type="password" placeholder="Password"
                                              class="login-input"></md-input>
                                </md-field>
                            </div>
                            <div class="actions">
                                <md-button id="sign-in" type="submit" class="md-primary md-ink-ripple md-raised">Sign In
                                </md-button>

                                <div class="line-item">
                                    <div class="left-item">
                                        <span v-if="wrongEmailIdmsgs" class="md-error">Please fill the above fields</span>
                                        <span v-if="wrongEmailIdmsg" class="md-error">Incorrect email  or   password!</span>
                                        <span v-if="siginInError" class="md-error">Incorrect  password!</span>
                                    </div>
                                    <div class="right-item">
                                        <p>
                                            <a class="login-text float-right cuattr" v-on:click="recoverPassword()">Forgot Password?</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script type="text/javascript">
import {mapActions, mapGetters} from 'vuex';
import axios from 'axios';
import {logout, maintenanceAction, maintenanceFlag, maintenanceFlagForIP, sendOtp} from '../../services/LoginService';

export default {
  metaInfo: {
    meta: [
      {name: 'viewport', content: 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1'}
    ]
  },
  data () {
    return {
      wrongEmailIdmsg: false,
      wrongEmailIdmsgs: false,
      email: null,
      password: null,
      rememberMe: true,
      siginInError: false,
      siginInErrorForOTP: false,
      flagForActive: false,
      flagForDeactive: false,
      inputOTP: '',
      ActiveString: 'As6pPqj3t7OBn2LQbZCUU7abvZx4',
      DeActiveString: 'As6pPqj3t7OBn2LQbZCUU7abvZx42',
      maintenance: false,
      count: localStorage.access_token.length
    };
  },
  computed: {
    ...mapGetters('user', ['isAdmin', 'isSignedIn', 'currentUser', 'isAdminEmailCheck']),
    ...mapGetters('client', ['clientLoaded'])
  },
  methods: {
    ...mapActions('user', ['signInUser', 'signInUserToken', 'signOutUser', 'cleanTokenFromCurrentUser', 'SendOtpModal']),
    ...mapActions('tours', ['clearCurrentTour']),
    ...mapActions('client', ['unloadClient']),
    async checkOtpSubmit () {
      this.siginInErrorForOTP = false;
      let self = this;
      await this.SendOtpModal(this.inputOTP).then(function (defs) {
        if (defs.data === 'ACTIVE') {
          self.siginInErrorForOTP = false;
          if (self.$route.query.maintenance === self.ActiveString) {
            maintenanceAction(1);
            self.maintenance = true;
            self.flagForActive = false;
            self.flagForDeactive = false;
          } else if (self.$route.query.maintenance === self.DeActiveString) {
            maintenanceAction(0);
            self.maintenance = false;
            self.flagForActive = false;
            self.flagForDeactive = false;
          }
        } else {
          self.siginInErrorForOTP = true;
        }
      });
    },
    async signIn () {
      try {
        this.wrongEmailIdmsg = false;
        this.siginInError = false;
        this.wrongEmailIdmsgs = false;
        if (this.email === '' || this.password === '') {
          this.wrongEmailIdmsgs = true;
          return false;
        } else {
          this.wrongEmailIdmsg = false;
        }
        await this.signInUser({email: this.email, password: this.password, rememberMe: this.rememberMe});
        if (this.isAdminEmailCheck === 1) {
          this.wrongEmailIdmsg = true;
          this.email = '';
          this.password = '';
          this.siginInError = false;
        }
        if (this.currentUser.access_token === undefined) {
          this.wrongEmailIdmsg = true;
          this.siginInError = false;
          this.email = '';
          this.password = '';
        } else {
          this.siginInError = false;
        }
        localStorage.access_token = this.currentUser.access_token;
        axios.defaults.headers.common['accessToken'] = this.currentUser.access_token;
        this.cleanTokenFromCurrentUser();
        if (this.isAdmin === true) {
          this.$router.push({path: 'client/list'});
        } else {
          this.$router.push({path: 'clients/switch'});
        }
      } catch (err) {
        console.error('Could not sign in user.', err);
      }
    },
    recoverPassword () {
      this.$router.push({path: '/forgot'});
    }
  },
  mounted () {
    let self = this;
    if (self.count > 10) {
      this.signInUserToken(localStorage.access_token).then(function (defs) {
        axios.defaults.headers.common['accessToken'] = localStorage.access_token;
        if (defs.data.length) {
          if (defs.data[0].isAdmin === 1) {
            self.$router.push({path: '/client/list'});
          } else {
            self.$router.push({path: '/clients/switch'});
          }
        } else {
          self.count = 0;
          localStorage.access_token = '';
        }
      });
    }
    maintenanceFlag().then(function (defs) {
      if (defs.data.is_maintenance === 1) {
        self.maintenance = true;
        self.flagForActive = false;
        self.flagForDeactive = false;
        if (self.$route.query.maintenance === self.DeActiveString) {
          sendOtp(self.$route.query.maintenance);
          self.flagForDeactive = true;
          self.maintenance = false;
        }
      } else {
        if (self.$route.query.maintenance === self.ActiveString) {
          sendOtp(self.$route.query.maintenance);
          self.maintenance = false;
          self.flagForActive = true;
        } else if (self.$route.query.maintenance === self.DeActiveString) {
          self.flagForDeactive = false;
          self.maintenance = false;
          self.flagForActive = false;
        }
      }
    });
    maintenanceFlagForIP().then(function (defs) {
      if (defs.data === 'Chetuiwk1455.chetu.com' || defs.data === '192.168.56.1' || defs.data === '192.168.99.1' || defs.data === 'India') {
        self.maintenance = false;
        self.flagForActive = false;
      }
    });
    delete axios.defaults.headers.common['accessToken'];
    delete axios.defaults.headers.common['userId'];
    if (this.isSignedIn) {
      logout(this.currentUser.id);
      this.signOutUser();
    }
    if (!this.isSignedIn && this.clientLoaded) {
      this.unloadClient();
      this.clearCurrentTour();
    }
  }
};
</script>

<style type="scss" scoped>
body {
    min-width: 100vw !important;
}

.logo {
    overflow: hidden;
    background: url(/static/img/logo.png);
    background-size: 288px 90px;
    width: 288px;
    height: 90px;
    margin: auto;
}

.login-form .md-field.md-has-password .md-toggle-password {
    padding-bottom: 10px;
    top: 8px !important;
}

span.md-error {
    color: red;
}

.login-form .md-checkbox {
    margin: 0px !important;
}

#sign-in {
    width: 100%;
    background-color: rgb(0, 168, 202) !important;
    color: white;
}

h1 {
    font-size: 50px;
    margin-bottom: 30px;
}

article {
    display: block;
    text-align: left;
    width: 600px;
    margin: 0 auto;
}

.maintance-box {
    float: left;
    width: 100%;
    margin: 123px 0px;
}

.btn-primary {
    margin: 30px 0 50px;
    width: 50%;
    padding: 6px;
    background-color: #B85FC6;
    border: none;
    text-transform: uppercase;
}

.classCheckOtp input {
    border-left: none;
    border-top: none;
    border-right: none;
    border-bottom: 1px solid #999 !important;
    height: 35px;
}

.maintanceWrapper {
    display: flex;
    background: #fff;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-wrap: wrap;
}

h1.heading {
    font-size: 38px;
    margin: 0;
    font-weight: 400;
    color: #153a5a;
}

.subHeading {
    font-size: 32px;
    display: block;
    margin: 20px 0 30px;
    color: #727072;
    padding: 0;
    position: relative;
    line-height: 35px;
}

.subHeading1 {
    font-size: 32px;
    display: block;
    margin: 20px 0 30px;
    color: #727072;
    padding: 0;
    position: relative;
}

.subHeading::before {
    content: "";
    position: absolute;
    bottom: -13px;
    left: 0;
    border-bottom: 1px solid #727072;
    width: 490px;
}

.subHeading1::before {
    content: "";
    position: absolute;
    bottom: -13px;
    left: 0;
    width: 490px;
}

.innerPanel p {
    color: #727072;
    font-size: 14px;
}

p.sorryText {
    font-size: 16px;
    margin-bottom: 10px;
    padding: 0;
    color: #727072;
}

.audioLogo {
    text-align: center;
    display: block;
    margin-bottom: 50px;
}

.cortexLogo {
    display: block;
    text-align: center;
}

.cortexLogo > img {
    width: 30%;
}

.innerPanel {
    flex: 0 0 60%;
}

.audioLogo1 {
    margin-bottom: 4%;
}

.login-text {
    margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Login.vue